<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Child Route View -->
      <router-view />
      <!-- end: Child Route View -->

      <div
        v-show="isHubRoute"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-chart-line"></i>
            </span>
            <h3 class="kt-portlet__head-title">Monitoring</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="row">
            <div class="col-xl-6 col-md-6 mb-4" v-for="card in cards" :key="card.path">
              <router-link :to="card.path" class="monitoring-card-link">
                <div class="kt-portlet kt-portlet--height-fluid monitoring-card">
                  <div class="kt-portlet__body text-center">
                    <div class="monitoring-card-icon mb-3">
                      <i :class="card.icon"></i>
                    </div>
                    <h4 class="monitoring-card-title">{{ card.title }}</h4>
                    <p class="monitoring-card-desc text-muted mb-0">{{ card.description }}</p>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    // เทียบแบบ case-insensitive — URL อาจเป็น /BudgetPlan/Monitoring หรือ /budgetplan/monitoring
    isHubRoute() {
      return this.$route.path.toLowerCase() === "/budgetplan/monitoring";
    },
  },
  data() {
    return {
      cards: [
        {
          path: "/BudgetPlan/Monitoring/SendApprovalGroup",
          icon: "fas fa-envelope fa-3x text-primary",
          title: "Budget Plan — Email Monitoring",
          description: "ดู log การส่งอีเมลแจ้งเตือนผู้อนุมัติ + manual trigger",
        },
        {
          path: "/BudgetPlan/Monitoring/BiSnapData",
          icon: "fas fa-database fa-3x text-success",
          title: "BI SnapData Monitoring",
          description: "ดู log การ snap ข้อมูลรายเดือนสำหรับ BI (BI_SnapDataLog)",
        },
      ],
    };
  },
};
</script>

<style scoped>
.monitoring-card-link {
  display: block;
  text-decoration: none;
  color: inherit;
}
.monitoring-card-link:hover {
  text-decoration: none;
}
.monitoring-card {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  border: 1px solid #ebedf2;
}
.monitoring-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  border-color: #5867dd;
}
.monitoring-card-icon {
  padding-top: 10px;
}
.monitoring-card-title {
  font-weight: 500;
  color: #48465b;
}
.monitoring-card-desc {
  font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/BudgetPlanMonitoring.vue